import { jsx as _jsx } from "react/jsx-runtime";
import { Box, CircularProgress } from '@mui/material';
var LoadingSpinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 40 : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c;
    return (_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', alignItems: 'center', p: 3 }, children: _jsx(CircularProgress, { size: size, color: color }) }));
};
export default LoadingSpinner;
